// extracted by mini-css-extract-plugin
module.exports = {"editButton":"o1"};